import _ from "lodash"
import ActionsPage from "pages/ActionsPage"
import CheckoutDiscountPage from "pages/checkout/CheckoutDiscountPage"
import CheckoutPaymentPage from "pages/checkout/CheckoutPaymentPage"
import React, {Component} from "react"
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom"
import {Button, Loader} from "semantic-ui-react"
import {I18n} from "react-polyglot"
import {observer} from "mobx-react"
import locale2 from "locale2"
import shop from "shop/shop"

import "semantic-ui-css/semantic.min.css"
import "./style/variables.scss"
import "./style/index.css"
import "theme/base/theme.scss"
import "global.scss"

import englishMessages from "locales/en.json"
import germanMessages from "locales/de.json"
import CMSIntegration from "components/CMSIntegration"

import Barcode from "components/Barcode/Barcode"
//LAYOUTS
import PageLayout from "layout/PageLayout"
import EmptyLayout from "layout/EmptyLayout"
import FooterLayout from "layout/FooterLayout"
import CheckoutLayout from "layout/CheckoutLayout"
import FullWidthLayout from "./layout/FullWidthLayout"
// PAGES
import HomePage from "pages/HomePageV2"
import CollectionPage from "pages/CollectionPage"
import TopsellerPage from "pages/topseller/TopsellerPage"
import TopsellerPagefwd from "pages/topseller/TopsellerPagefwd"
import ExplorerPage from "pages/ExplorerPage"
import CollectionExtraPage from "pages/CollectionExtraPage"
import BrandPage from "pages/BrandPage"
import ProductPage from "pages/ProductPage"
import SearchPage from "pages/SearchPage"
import QuickorderPage from "pages/quickorder/QuickorderPage"
import CmsPage from "pages/CmsPage"
import PostPage from "pages/PostPage"
import LoginPage from "pages/LoginPage"
import CheckoutPage from "pages/checkout/CheckoutPage"
import CheckoutPageCoupon from "pages/checkout/CheckoutPageCoupon"
import NewCustomerPageGuest from "pages/checkout/NewCustomerPageGuest"
import SuccessPage from "pages/checkout/SuccessPage"
import ConfirmationPage from "pages/checkout/ConfirmationPage"
import DeliveryPage from "pages/checkout/DeliveryPage"
import DeliveryPageCoupon from "pages/checkout/DeliveryPageCoupon"
import AddressBookPage from "pages/checkout/AddressBookPage"
import AccountPage from "pages/AccountPage"
import AccountOrderDetailPage from "pages/AccountOrderDetailPage"

import ReturnPage from "pages/returnCheckout/ReturnPage"
import InventoryPage from "pages/returnCheckout/InventoryPage"
import ReturnPageMain from "pages/returnCheckout/ReturnPageMain"
import ReturnPageContactPerson from "pages/returnCheckout/ReturnPageContactPerson"
import ReturnPageHelp from "pages/returnCheckout/ReturnPageHelp"
import ReturnPageContact from "pages/returnCheckout/ReturnPageContact"
import ReturnPageConfirmation from "pages/returnCheckout/ReturnPageConfirmation"
import ReturnPageSuccess from "pages/returnCheckout/ReturnPageSuccess"
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader"
import ReturnPageQuantity from "pages/returnCheckout/ReturnPageQuantity"
import ReturnAdminPage from "pages/returnCheckout/ReturnAdminPage"

import OrderlistPage from "pages/orderlist/OrderlistPage"
import RegisterPage from "pages/RegisterPage"
import NotFoundPage from "pages/NotFoundPage"
import AdminPage from "pages/AdminPage"


import LandingPage from "pages/LandingPage"

import LogoutPage from "pages/LogoutPage"
import NewCustomerPage from "pages/NewCustomerPage"
import NewCustomerContactPage from "pages/NewCustomerContactPage"
import CustomerEnablingPage from "pages/CustomerEnablingPage"
import FormPage from "pages/form/FormPage"
import UploadPage from "pages/form/UploadPage"
import FormDebuggerPage from "pages/form/FormDebuggerPage"

import FilterPage from "pages/FilterPage"

import RouteWithLayout from "layout/RouteWithLayout"
import RouteWithLogin from "layout/RouteWithLogin"

import ScrollToTop from "components/ScrollToTop/ScrollToTop"
import Tracker from "components/Tracker/Tracker"

import cmsStore from "stores/cmsStore"
import languageStore from "stores/languageStore"

import ShoppableImage from "components/ShoppableImage/ShoppableImage"
import ShoppableImageDashboard from "components/ShoppableImage/ShoppableImageDashboard"
import ShoppableCategoryPage from "components/ShoppableImage/ShoppableCategoryPage"
import ResetPasswordPage from "pages/ResetPasswordPage"
import RequestPasswordPage from "pages/RequestPasswordPage"
// CONTACT FORMS
window.shop = shop // TODO DEBUG


import ReactGA from "react-ga"
import MerklistePage from "pages/merkliste/MerklistePage";
import TopNotification from "components/Segment/TopNotification";
const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID; // YOUR_OWN_TRACKING_ID
TRACKING_ID && ReactGA.initialize(TRACKING_ID);
console.log( "INITIALIZED GA" )
// console.log( "GTM CONTAINER", process.env.REACT_APP_GTM_CONTAINER )
// require the correct plugin

const cartUpdate = _.debounce( () => {
	shop.cart.get()
}, 1550, {leading: true, trailing: false} )

window.onfocus = function () {

	//cartUpdate()
	
};

window.onblur = function () {

};

let visualDebugMode = false

@observer
class App extends Component {

	state = {...this.makeLocale( locale2 ), ready: false,}

	makeLocale( locale ) {
		return {
			locale  : locale,
			messages: locale.indexOf( "de" ) !== -1 ? germanMessages : englishMessages
		}
	}

	constructor() {
		super()

		try {
			visualDebugMode = _.includes( document.location.search, "visualDebug=true" )
		} catch ( err ) {
			// NOTHING
			console.warn( "ERROR PARSING VISUAL DEBUG MODE", err )
		}

		Promise.all( [
				cmsStore.getConfig()
					.then( config => {
						console.log( {config} )
						Object.assign( shop.config, config )
						if(!shop.config.MIN_ORDER_VALUE){
							shop.config.MIN_ORDER_VALUE =  0
						}
						if(!shop.config.pageSiz){
							shop.config.pageSize =  24
						}
						console.log("GET CONFIG: ",config)
						// if ( !config.login_wall ) shop.loadCategories()
						return shop.whoami()
							.then( profile => {
								if ( !profile && shop.config.login_wall ) return shop.loadCategories()
								return shop.loadCategories()
							} )
					} )
			] )
			.then( () => this.setState( {ready: true} ) )
	}

	render() {
		const {ready, error} = this.state

		const {isEditor, useEditor} = cmsStore

		if ( error ) {
			return <div className="tc pa5">
				{`${error}`}
			</div>
		}

		if ( !ready ) {
			return <div>
				<Loader />
			</div>
		}
		const {before = null, children, components = null} = this.props
		let {locale, messages} = languageStore
		return (
			<React.Fragment>
				<link rel="manifest" href="public/site.webmanifest"></link>
				{shop.config.custom_css &&
				<style dangerouslySetInnerHTML={{__html: shop.config.custom_css}} />}
				<I18n locale={locale} messages={messages}>
					<React.Fragment>
						{components}
						<Router>
							<Route exact path={"/"} component={TopNotification}/>
							<Route exact path={"/home/"} component={TopNotification}/>
							<div>
								{before}
								<div
									className={`AppWrapper ${visualDebugMode ? "VISUAL_DEBUG_MODE_ON" : ""} ${shop.session ? "logged-in" : "logged-out"} ${isEditor ? "isEditor" : ""} ${useEditor ? "editor-enabled" : ""}`}>
									<Route path="/:url*" exact strict render={props => <Redirect to={{
										pathname: `${props.location.pathname}/`,
										search  : props.location.search
									}} />} />

									<ScrollToTop />
									<Barcode />
									<CMSIntegration />
									<Switch>
										{children}
										<Route path="/wp/" strict component={() => {
											document.location.reload()
											return <div><Button loading /></div>
										}} />
										<RouteWithLayout layout={FullWidthLayout} path="/welt" component={LandingPage} />
										<RouteWithLogin layout={PageLayout} exact path="/" component={HomePage} />
										<RouteWithLogin layout={PageLayout} exact path="/home" component={HomePage} />
										<RouteWithLogin layout={PageLayout} exact path="/account"
														component={AccountPage} />
										<RouteWithLogin layout={PageLayout} exact path="/account/orders/:orderId" component={AccountOrderDetailPage} />
										<RouteWithLogin layout={PageLayout} exact path="/account/orders/:backOrderMode/:orderId" component={AccountOrderDetailPage} />
										<RouteWithLogin layout={PageLayout} exact path="/form/:slug" component={FormPage} />
										<RouteWithLogin layout={PageLayout} exact path="/upload" component={UploadPage} />
										<RouteWithLogin layout={PageLayout} exact path="/form-debugger/:slug" component={FormDebuggerPage} />

										<RouteWithLogin layout={PageLayout} exact path="/explore/:categoryId" component={ExplorerPage} />
										{shop.config.plugin.infiniteScroll &&
										<RouteWithLogin layout={PageLayout} exact path="/collection/:categoryId" component={ExplorerPage} />}

										{(!shop.config.plugin.filterpagev2 && !shop.config.plugin.filterpagev3) &&
										<RouteWithLogin layout={PageLayout} exact path="/topseller" component={TopsellerPage} />}
										{(!shop.config.plugin.filterpagev2 && !shop.config.plugin.filterpagev3) &&
										<RouteWithLogin layout={PageLayout} exact path="/topsellerfwd" component={TopsellerPagefwd} />}
										{(!shop.config.plugin.filterpagev2 && !shop.config.plugin.filterpagev3) &&
										<RouteWithLogin layout={PageLayout} exact path="/collection" component={CollectionPage} />}
										{(!shop.config.plugin.filterpagev2 && !shop.config.plugin.filterpagev3) &&
										<RouteWithLogin layout={PageLayout} exact path="/collection/:parent" component={CollectionPage} />}
										{(!shop.config.plugin.filterpagev2 && !shop.config.plugin.filterpagev3) &&
										<RouteWithLogin layout={PageLayout} exact path="/collection/:parents*/:id" component={CollectionPage} />}

										<RouteWithLogin layout={PageLayout} path="/collection/:categories*" component={FilterPage} />
										<RouteWithLogin layout={PageLayout} path="/filter/:categories*" component={FilterPage} />

										<RouteWithLogin layout={PageLayout} exact path="/collection-extra/:extra/:extraValue" component={CollectionExtraPage} />

										<RouteWithLogin layout={PageLayout} exact path="/bildwelt/" component={ShoppableImageDashboard} />
										<RouteWithLogin layout={PageLayout} exact path="/bildwelt/:categorySlug" component={ShoppableCategoryPage} />
										<RouteWithLogin layout={PageLayout} exact path="/bildwelt/:categorySlug/:slug" component={ShoppableImage} />

										<RouteWithLogin layout={PageLayout} exact path="/brand/:id" component={BrandPage} />
										<RouteWithLogin layout={PageLayout} exact path="/product/:productId" component={ProductPage} />
										<RouteWithLogin layout={PageLayout} exact path="/quickorder" component={QuickorderPage} />
										<RouteWithLogin layout={PageLayout} exact path="/orderlist" component={OrderlistPage} />
										<RouteWithLogin layout={PageLayout} exact path="/orderlist/:id" component={OrderlistPage} />
										<RouteWithLayout layout={PageLayout} exact path="/list" component={MerklistePage} />
										<RouteWithLayout layout={PageLayout} exact path="/list/:id" component={MerklistePage} />
										<RouteWithLogin layout={PageLayout} exact path="/cms/:slug" component={CmsPage} />

										<RouteWithLogin layout={PageLayout} exact path="/post/:slug"
														component={PostPage} />
										<RouteWithLogin layout={PageLayout} exact path="/register"
														component={RegisterPage} />
										<RouteWithLogin layout={PageLayout} exact path="/admin" component={AdminPage} />

										<RouteWithLogin layout={PageLayout} exact path="/search"
														component={SearchPage} />
										<RouteWithLogin layout={PageLayout} exact path="/aktionen/:searchTerm"
														component={ActionsPage} />
										<RouteWithLogin layout={PageLayout} exact path="/aktionen/code/:searchTerm"
														component={ActionsPage} />


										<RouteWithLayout layout={EmptyLayout} exact path="/login"
														 component={LoginPage} />
										<RouteWithLayout layout={FooterLayout} exact path="/reset_password"
														 component={ResetPasswordPage} />
										<RouteWithLayout layout={FooterLayout} exact path="/request_password"
														 component={RequestPasswordPage} />
										<RouteWithLayout layout={FooterLayout} exact path="/customer_registration"
														 component={NewCustomerPage} />
										<RouteWithLayout layout={PageLayout} exact path="/customer_contact"
														 component={NewCustomerContactPage} />				 
										<RouteWithLayout layout={FooterLayout} exact path="/login/customer_registration"
														 component={NewCustomerPage} />
										<RouteWithLayout layout={FooterLayout} exact path="/customer_enabling"
														 component={CustomerEnablingPage} />
										<RouteWithLayout layout={EmptyLayout} exact path="/logout"
														 component={LogoutPage} />

										<RouteWithLayout layout={EmptyLayout} exact path="/return" component={ReturnPage} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/inventory"	component={InventoryPage} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/main"	component={ReturnPageMain} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/contactPerson"	component={ReturnPageContactPerson} />

										<RouteWithLayout layout={EmptyLayout} exact path="/return/help"	component={ReturnPageHelp} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/contact"	component={ReturnPageContact} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/confirmation"	component={ReturnPageConfirmation} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/success"	component={ReturnPageSuccess} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/header"	component={ReturnPageHeader} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/quantity"	component={ReturnPageQuantity} />
										<RouteWithLayout layout={EmptyLayout} exact path="/return/admin"	component={ReturnAdminPage} />


										<RouteWithLogin layout={EmptyLayout} exact
														path="/checkout/:checkoutType?/payment/:orderId?"
														component={CheckoutPaymentPage} />
										<RouteWithLayout layout={CheckoutLayout} exact
														 path="/checkout/:checkoutType?/discount"
														 component={CheckoutDiscountPage} />
										<RouteWithLayout layout={CheckoutLayout} exact
														 path="/checkoutCpn/:checkoutType?/checkout"
														 component={CheckoutPageCoupon} />
										<RouteWithLogin layout={CheckoutLayout} exact
														path="/checkout/:checkoutType?/delivery"
														component={DeliveryPage} />
										<RouteWithLogin layout={CheckoutLayout} exact
														path="/checkout/:checkoutType?/deliveryCpn"
														component={DeliveryPageCoupon} />
										<RouteWithLogin layout={CheckoutLayout} exact
														path="/checkout/:checkoutType?/addresses"
														component={AddressBookPage} />
										<RouteWithLogin layout={CheckoutLayout} exact
														path="/checkout/:checkoutType?/customer"
														component={NewCustomerPageGuest} />
										<RouteWithLogin layout={CheckoutLayout} exact
														path="/checkout/:checkoutType?/confirmation"
														component={ConfirmationPage} />
										<RouteWithLogin layout={PageLayout} exact
														path="/checkout/:checkoutType?/success"
														component={SuccessPage} />
										<RouteWithLogin layout={CheckoutLayout} exact path="/checkout/:checkoutType?"
														component={CheckoutPage} />
										<RouteWithLayout layout={PageLayout} component={NotFoundPage} />
									</Switch>
									<Tracker />
								</div>
							</div>
						</Router>
					</React.Fragment>
				</I18n>
			</React.Fragment>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./src/theme/base/App.js